// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe4aafe8","455":"540dd050","977":"aae763e1"}[chunkId] + ".chunk.js";
};